export default __webpack_public_path__ + "static/media/persiana-ceilan.34cffbf3.jpg";